import functions from "./functions.js";

$(function () {

    const $form = $('.form-contact');
    const form = $form[0];

    if (!form) {
        return;
    }

    $form.on('submit', e => {
        e.preventDefault();

        let params = {};
        $.each($form.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = functions.getLang();       

        $form.find('.btn-contact')
            .prop('disabled', true)
            .find('.la-spinner').removeClass('d-none');
        
        grecaptcha.enterprise.ready(function () {
            grecaptcha.enterprise.execute('6Lcund0sAAAAAEIOHzAuUX9qaowZ34zWpKAEnPxp', { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);
                params['recaptchaType'] = 'enterprise';
                //console.log(params);
                $.post('/services/contact/', params).then(response => {
                    //console.log(response);
                    response = JSON.parse(response);

                    $form.find('.btn-contact')
                        .prop('disabled', false)
                        .find('.la-spinner').addClass('d-none');

                    if ( response.status == true ) {
                        if (typeof fbq === 'function') fbq('track', 'Contact');
                        response.data = '<i class="la la-check-circle la-3x me-4"></i>' + response.data;
                        $form.find(".response-output").removeClass('d-none').addClass('border-secondary').html(response.data);
                        form.reset();
                    } else {
                        response.data = '<i class="la la-exclamation-circle la-3x me-4"></i>' + response.data;
                        $form.find(".response-output").removeClass('d-none').addClass('border-danger').html(response.data);
                    }

                    setTimeout(() => {
                        $form.find(".response-output").addClass('d-none').removeClass('border-secondary border-danger').html('');
                    }, 6000);
                });
            });
        });

    });

});